/**
 * 微信、支付宝 支付选择组件
 */
import React from 'react'
import {connect} from 'react-redux'
import {browserHistory} from 'react-router'
import {Mask} from 'react-weui'
import {WKBottomBtn} from './wk'
import {renderMoney} from '../utils'
import '../css/common/PayChoose.css'
import classnames from 'classnames';
import axios from 'axios'
import Config from '../config';
export const showHuaBeiPrice = 100000 // 单位：分

const payWayList = [
  { type: 'wx', text: '微信支付', image: 'https://static-cos.lycheer.net/xupload/20200722_wx.png' },
  { type: 'aliStage', text: '花呗分期支付', image: 'https://static-cos.lycheer.net/xupload/20200722_stage.png' },
  { type: 'alipay', text: '支付宝支付', image: 'https://static-cos.lycheer.net/xupload/20200722_alipay.png' },
]
let isPgc = null
class PayChoose extends React.Component {

  state = {
    type: 'wx',
    isPgc
  };
  constructor() {
    super()
    this.getPayWayList()
  }
  getPayWayList(){
    if(typeof isPgc === 'boolean') return
    let query = browserHistory.getCurrentLocation().query
    axios.get('/v1/integration/wk_staff/outer/organization.is_in_pgc.get', {
      baseURL: Config.BASE_URL_ELSE,
      params: {
        org_code: query && query.liveroom_id,
        sys_name: 'wk_staff',
        token: localStorage.getItem('Session/token')
      }
  }).then(({data}) => {
    isPgc = data && data.data && data.data.is_pgc_liverooms
    this.setState({isPgc})
    }).catch(console.error)
  }
    render() {
        const btnContent = {
            text: '下一步',
            method: () => {
                this.props.onPayNext ? this.props.onPayNext(this.state.type) : null
            }
        };

        return (
            <div className="paychoose__container">
                <Mask onClick={() => this.props.handleClose()}/>
                <div className={`paychoose`}>
                    <div className="paychoose__title">
                      <span className='desc'>选择支付方式</span>
                    </div>
                    <div className="prompt_text">
                      <img src="https://static-cos.lycheer.net/xupload/20200722_shield.png" />支付环节安全保障中
                    </div>
                    <ul className="paychoose__content">
                      {
                        payWayList.map((v, index)=>{
                          if(v.type === 'aliStage' && !(this.state.isPgc === true && +this.props.realPrice >= showHuaBeiPrice)) return
                          return <li
                          key={'pay-item-' + index}
                          className={
                            classnames(
                              this.state.type === v.type && 'pay-item-active',
                              'pay-item'
                            )
                          }
                          onClick={() => {
                            this.setState({
                              type: v.type
                            })
                          }}
                        >
                          <img src={v.image} />
                          <span>{v.text}</span>
                        </li>
                        })
                      }
                    </ul>
                    <WKBottomBtn btnContent={btnContent}/>
                </div>
            </div>
        )
    }
}

export default connect(state => ({

}))(PayChoose)



// WEBPACK FOOTER //
// ./src/components/PayChoose.js